import Actions from 'Actions';
import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import type { StorytellerState } from 'store/StorytellerReduxState';

export interface ModalReducerState {
  isEditMetadataOpen: boolean;
  editMetadataAutoFocusField: string | null;
}

const initialState: ModalReducerState = {
  isEditMetadataOpen: false,
  editMetadataAutoFocusField: null,
};

/* Action Creators */
export const openEditMetadataModal = createAction(
  Actions.EDIT_METADATA_MODAL_OPEN,
  (autoFocusField?: string) => ({ payload: autoFocusField }),
);
export const closeEditMetadataModal = createAction(Actions.EDIT_METADATA_MODAL_CLOSE);

/**
 * ENGINEER NOTE: This reducer should be removed. We should not be storing component state in
 * redux. Once we convert the setting panel to React, we should remove this reducer.
 */

export const modalReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(openEditMetadataModal, (state, action) => {
      state.isEditMetadataOpen = true;
      state.editMetadataAutoFocusField = action.payload ?? null;
    })
    .addCase(closeEditMetadataModal, (state) => {
      state.isEditMetadataOpen = false;
      state.editMetadataAutoFocusField = null;
    });
});
export const selectModalsReducer = (state: StorytellerState) => state.modals;

export const selectIsEditMetadataModalOpen = createSelector(
  selectModalsReducer,
  (slice) => slice.isEditMetadataOpen,
);

export const selectEditMetadataAutoFocusField = createSelector(
  selectModalsReducer,
  (slice) => slice.editMetadataAutoFocusField,
);
